<template>
    <div class="" v-loading="loading" element-loading-text="查询中...">
        <div class="content-caption dashed">
            <span>询盘信息</span>
        </div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label>询盘名称</label>
                </div>
                <div class="form-value">
                    <span>{{dealInqryVoucher.title}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>截止日期</label>
                </div>
                <div class="form-value">
                    <span>{{dealInqryVoucher.expireDate}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">内容摘要</div>
                <div class="form-value">
                    <div>
                        <span>{{dealInqryVoucher.digest}}</span>
                        <a class="swb-btn-link" :class="{'display-none':!isShow}" @click="checkContent">查看</a>
                    </div>
                    <div :class="{'display-none':isShow}">
                        <swb-ck-editor ref="theCkEditor" :content="content" :imageXtHandler="imageXtHandler"></swb-ck-editor>
                    </div>
                    <i class="swb-btn-link" :class="{'display-none':isShow}" @click="hiddleCount()">隐藏内容</i>
                </div>

            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>联系人</label>
                </div>
                <div class="form-value">
                    <span>{{dealInqryVoucher.contactName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>联系电话</label>
                </div>
                <div class="form-value">
                    <span>{{dealInqryVoucher.contactTel}}</span>
                </div>
            </div>
        </div>
        <div class="simple-form" v-if="showFlag">
            <div class="form-group center">
                <div class="form-label">
                    <label>询盘类型</label>
                </div>
                <div class="form-value">
                    <span v-if="dealInqryVoucher.tradeType == tradeTypeGoodsEnum.value">{{tradeTypeGoodsEnum.text}}</span>
                    <span v-if="dealInqryVoucher.tradeType == tradeTypeServcEnum.value">{{tradeTypeServcEnum.text}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">询盘方式</div>
                <div class="form-value">
                    <span v-if="dealInqryVoucher.directed">定向询盘</span>
                    <span v-else>公开询盘</span>
                </div>
            </div>
            <div class="form-group center" v-if="dealInqryVoucher.directed">
                <div class="form-label">询盘商户</div>
                <div class="form-value">
                    <ul class="clearfix">
                        <li class="mr20 fl" v-for="dealInqryMercht in dealInqryVoucher.dealInqryMerchtList">{{dealInqryMercht.merchantName}}</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label>询盘地址</label>
                </div>
                <div class="form-value">
                    <span>{{dealInqryVoucher.deliverAddr}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>申请描述</label>
                </div>
                <div class="form-value">
                    <span>{{dealInqryVoucher.applyDesc}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>审核描述</label>
                </div>
                <div class="form-value">
                    <span>{{dealInqryVoucher.auditDesc}}</span>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>报盘详情</span>
            <span class="fr font12" v-if="dealInqryVoucher.directed">本次询盘共定向询盘{{merchantCount}}家商户，总共有{{dealInqryVoucher.dealReplyVoucherCount}}报盘</span>
            <span class="fr font12" v-else>本次询盘公开询盘，总共有{{dealInqryVoucher.dealReplyVoucherCount}}报盘</span>
        </div>
        <div v-if="dealInqryVoucher.dealReplyVoucherCount > 0">
            <swb-deal-reply-voucher-list :inqryVoucherId="id"></swb-deal-reply-voucher-list>
        </div>
    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import dealApi from '../../api/deal'

    import SwbDealReplyVoucherList from './DealReplyVoucherList';
    Vue.regist(SwbDealReplyVoucherList);

    import SwbCkEditor from '../ctrl/CkEditor';
    Vue.regist(SwbCkEditor);

    export default{
        name: 'swb-deal-inqry-voucher-info',
        desc: '询盘单详情',
        props: ['id', 'showFlag', 'audit'],
        data: function () {
            return {
                loading: true,
                dealInqryVoucher: {},
                tradeTypeGoodsEnum: {},
                tradeTypeServcEnum: {},
                isShow: true,
                merchantCount: null,
                content: null
            }
        },
        created: function () {
            let self = this;
            self.tradeTypeGoodsEnum = getEnumInfoWith('tradeType', 'name', 'Goods');
            self.tradeTypeServcEnum = getEnumInfoWith('tradeType', 'name', 'Servc');
            self.getDealInqryVoucherById();
        },
        methods: {
            imageXtHandler: function (ckEditor) {
                //
            },
            getDealInqryVoucherById: function () {
                let self = this;
                let postData = {};
                postData.id = self.id;
                let lastMsgBoxDlg = MsgBox.loading();
                dealApi.getDealInqryVoucher(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == "info") {
                        let dealInqryVoucher = result.data;
                        self.dealInqryVoucher = dealInqryVoucher;
                        if(!Utils.isNoB(dealInqryVoucher.dealInqryMerchtList)) {
                            self.merchantCount = dealInqryVoucher.dealInqryMerchtList.length;
                        }
                        self.content = self.dealInqryVoucher.dealInqryCont.content;
                        //
                        self.loading = false;
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            checkContent: function () {
                let self = this;
                self.isShow = false;
            },
            hiddleCount: function () {
                this.isShow = true;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/InqryVoucher/DealInqryVoucherInfo.vue